export const getValidationState = (meta: any) => {
  return meta?.touched ? (meta?.valid ? 'is-valid' : 'is-invalid') : null
}
